/**
 * Copyright © 2020-2026 Delicious AI, LLC
 */

import './utils/sentry'
import 'animate.css/animate.min.css'
import 'chart.js/auto'
import 'react-app-polyfill/stable'
import './firebaseui-styling.global.css'

import { TolgeeProvider } from '@tolgee/react'
import React from 'react'
import { createRoot } from 'react-dom/client'
import { BrowserRouter } from 'react-router-dom'

import { ThemeProvider } from '@/contexts/ThemeContext'
import { tolgee } from '@/i18n/tolgee'
import reportWebVitals from '@/utils/reportWebVitals'

import { ApolloClientGate } from './App'

const container = document.getElementById('root')
const root = createRoot(container!)

root.render(
  <React.StrictMode>
    <BrowserRouter>
      <TolgeeProvider tolgee={tolgee}>
        <ThemeProvider>
          <ApolloClientGate />
        </ThemeProvider>
      </TolgeeProvider>
    </BrowserRouter>
  </React.StrictMode>,
)

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals()
